import React, { Component } from 'react';
import './style.css'
class Pagination extends Component {

    render() {
        var { totalProduct, postPerPage, currentPage } = this.props;
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(totalProduct / postPerPage); i++) {
            pageNumbers.push(i)
        }
        return (
            <div>
                <ul className="pagination-numbers">
                    <li>
                        <button
                            className="pagination-button pagination-button-prev"
                            onClick={() => {
                                this.props.paginate(currentPage - 1)
                            }} disabled={currentPage === 1 ? true : false}>
                            Prev
                        </button>
                    </li>
                    {pageNumbers.map((number, index) => (
                        <li
                            key={index}
                            className={`pagination-btn ${number === currentPage ? 'active' : ''}`}
                            onClick={() => this.props.paginate(number)}
                        >
                            {number}
                        </li>
                    ))}
                    <li>
                        <button
                            className="pagination-button pagination-button-next"
                            onClick={() => {
                                this.props.paginate(currentPage + 1)
                            }} disabled={currentPage === Math.ceil(totalProduct / postPerPage) ? true : false}>
                            Next
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}

export default Pagination;
